import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import styled from 'styled-components';
import t from '../application/translate';

export default function Loader() {
  return (
    <LoaderContainer>
      <TextBox>
        {/* <p>{t('loader')}</p> */}
        <LinearProgress color='primary' style={{width: '100%', marginTop: 8}} />
      </TextBox>
    </LoaderContainer>
  );
}

const LoaderContainer = styled.div`
  position: relative;
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0,0,0,.3);
`;

const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  position:absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 320px;
  justify-content: center;
  align-items: center;
  background: #f9f8f2;
  padding: 24px;
  border-radius: 3px;
  font-size: 1.5em;
  font-weight: bold;
`;



// WEBPACK FOOTER //
// ./src/Wizard/Loader.js